<template>
	<div>
		<div v-if="isFetching">
			<p>
				<dc-icon icon="sync" fixed-width no-margin spin /> {{ title }}
			</p>
		</div>
		<slot v-else></slot>
	</div>
</template>

<script>
export default {
	name: "IsFetching",
	props: {
		isFetching: {
			type: Boolean,
			default: () => false
		},
		title: {
			type: String,
			default: () => null
		}
	}
};
</script>
